import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./shared/components/ui/authentication/page404/page404.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { Role } from "./shared/models/role";
import { AuthLayoutComponent } from "./shared/components/main-view/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./shared/components/main-view/app-layout/main-layout/main-layout.component";
import {environment} from "../environments/environment";
import {PermissionValidaGuard} from "./shared/guards/permission.valida.guard";
const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'trabajador',
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [
              environment.PERMISO.GEST_TRAB_VALIDAR_FOTOCHECK,
              environment.PERMISO.GEST_TRAB_GESTION,
              environment.PERMISO.GEST_TRAB_CESADOS,
              environment.PERMISO.GEST_TRAB_IMPORTADOR,
          ]
        },
        loadChildren: () => import('./modules/trabajador/trabajador-lista.module').then(m => m.TrabajadorListaModule),
      },
      {
        path: 'sistema',
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [
              environment.PERMISO.DATA_TRAB_ACCESOS_PC,
              environment.PERMISO.DATA_TRAB_INVENTARIO,
              environment.PERMISO.DATA_TRAB_ACCESOS_GENERALES,
              environment.PERMISO.DATA_TRAB_REGISTRO_EQUIPOS,
              environment.PERMISO.DATA_TRAB_REGISTRO_TELEFONO,
              environment.PERMISO.DATA_TRAB_IMPORTADOR
          ]
        },
        loadChildren: () => import('./modules/datasistema/datasistema.module').then(m => m.DatasistemaModule),
      },
      {
        path: 'usuario',
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [environment.PERMISO.GESTION_USUARIOS]
        },
        loadChildren: () => import('./modules/usuario/usuario-lista.module').then(m => m.UsuarioListaModule),
      },
      {
        path: 'pishing',
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [environment.PERMISO.CAMPANAS_PHISHING]
        },
        loadChildren: () => import('./modules/pishing/pishing.module').then(m => m.PishingModule),
      },
      {
        path: 'climalaboral',
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [environment.PERMISO.CLIMA_LABORAL]
        },
        loadChildren: () => import('./modules/climalaboral/climalaboral.module').then(m => m.ClimalaboralModule),
      },

      {
        path: 'planilla',
        canActivate: [PermissionValidaGuard],
        data: { permissionList: [environment.PERMISO.PLANILLA] },
        loadChildren: () => import('./modules/planilla/planilla.module').then((m) => m.PlanillaModule),
      },
      {
        path: 'desempeno',
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [environment.PERMISO.DESEMPENO]
        },
        loadChildren: () => import('./modules/desempeno/desempeno.module').then(m => m.DesempenoModule),
      },
      {
        path: "registro",
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [
            environment.PERMISO.REGISTRO_SEDES,
            environment.PERMISO.REGISTRO_AREAS,
            environment.PERMISO.REGISTRO_PUESTOS,
            environment.PERMISO.REGISTRO_CORREOS,
            environment.PERMISO.REGISTRO_EMPRESA
          ]
        },
        loadChildren: () =>
          import("./modules/registro/registro.module").then((m) => m.RegistroModule),
      },
      {
        path: "asistencia",
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [
            environment.PERMISO.ASISTENCIA_REPORTE_GENERAL,
            environment.PERMISO.ASISTENCIA_REPORTE_JEFE,
            environment.PERMISO.ASISTENCIA_CONSOLIDADO_HORAS
          ]
        },
        loadChildren: () =>
          import("./modules/asistencia/asistencia.module").then((m) => m.AsistenciaModule),
      },
      {
        path: "solicitud",
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [
            environment.PERMISO.SOLICITUD_VACACIONES,
            environment.PERMISO.SOLICITUD_MOVILIDAD,
            environment.PERMISO.SOLICITUD_CUPONES,
            environment.PERMISO.SOLICITUD_DESCANSO_MEDICO
          ]
        },
        loadChildren: () =>
          import("./modules/solicitud/solicitud.module").then((m) => m.SolicitudModule),
      },
      {
        path: "seguimiento",
        loadChildren: () =>
          import("./modules/seguimiento/seguimiento-lista.module").then((m) => m.SeguimientoListaModule),
      },
      {
        path: "reportes",
        canActivate: [PermissionValidaGuard],
        data: {
          permissionList: [environment.PERMISO.REPORTES]
        },
        loadChildren: () =>
          import("./modules/reportes/reportes-lista.module").then((m) => m.ReportesListaModule),
      },
    ],
  },
  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./shared/components/ui/authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "landing",
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/landing-pishing/landing-pishing.module').then(m => m.LandingPishingModule),
  },
  {
    path: "encuesta",
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/landing-clima/landing-clima.module').then(m => m.LandingClimaModule),
  },
  {
    path: "info",
    component: AuthLayoutComponent,
    loadChildren: () => import('./modules/info/info.module').then(m => m.InfoModule),
  },
  {
    path: "external",
    loadChildren: () => import("./modules/external/external.module").then(
      (m) => m.ExternalModule)
  },
  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
